import { types } from 'mobx-state-tree'
import { resolveEndpoint } from '../../utils'


const PlayerConfig = types.model('PlayerConfig', {
    header_title: types.optional(types.string, ''),
    logo: types.optional(types.string, ''),
    text: types.optional(types.string, ''),
    embed: types.optional(types.string, ''),
    newLogo: types.maybe(types.frozen()),
    newLogoPreview: types.maybe(types.string),
}).actions(self => ({

    setHeaderTitle(value) {
        self.header_title = value
    },

    setLogo(value) {
        self.newLogo = value
        self.newLogoPreview = URL.createObjectURL(self.newLogo)
    },

    setText(value) {
        self.text = value
    },

    setEmbed(value) {
        self.embed = value
    },

})).views(self => ({

    get serialized() {
        return {
            header_title: self.header_title,
            logo: self.logo,
            text: self.text,
            embed: self.embed,
        }
    },

    get isValid() {
        return !!self.header_title && !!self.displayedLogo && !!self.text && !!self.embed
    },

    get displayedLogo() {
        return self.newLogoPreview || resolveEndpoint('/' + self.logo)
    },

}))

export default PlayerConfig
